import type { Source } from "@/types/api"

export type SourceGroupKey = "files" | "mail" | "chat"

export interface SourceGroup {
  key: SourceGroupKey
  label: string
  /** `number` is the 1-based index in the ORIGINAL sources array — what inline citation badges use. */
  items: { source: Source; number: number }[]
}

const GROUPS: { key: SourceGroupKey; label: string }[] = [
  { key: "files", label: "Files" },
  { key: "mail", label: "Mail" },
  { key: "chat", label: "Chats" },
]

export function sourceGroupKey(source: Source): SourceGroupKey {
  return source.kind === "mail" ? "mail" : source.kind === "chat" ? "chat" : "files"
}

/**
 * Group sources by type (Files, Mail, Chats — in that order, empty groups omitted).
 * Each item keeps its original number (index + 1), so numbers inside a group may be
 * non-contiguous and still match the citation badges in the answer text.
 */
export function groupSources(sources: Source[]): SourceGroup[] {
  const groups: SourceGroup[] = GROUPS.map((g) => ({ ...g, items: [] }))
  sources.forEach((source, i) => {
    const key = sourceGroupKey(source)
    groups.find((g) => g.key === key)!.items.push({ source, number: i + 1 })
  })
  return groups.filter((g) => g.items.length > 0)
}
